import script from "./goRinSyo0081.vue?vue&type=script&setup=true&lang=js"
export * from "./goRinSyo0081.vue?vue&type=script&setup=true&lang=js"

import "./goRinSyo0081.vue?vue&type=style&index=0&id=9ff6123a&lang=scss"

const __exports__ = script;

export default __exports__